module.exports = __webpack_public_path__ + "img/sunny milk_sc2.25be6272.png";